import { flatpickr, datetimepickerOptions } from './flatpickr'
import { ParamInserter } from './param-inserter'

const unavailablePeriodLimit = 100

function removeRow() {
  $(this).parent().remove()
}

$(document).ready(function() {
  const pickerOptions = { ...datetimepickerOptions, minuteIncrement: 30 }

  $('.office-viewing-setting .add-unavailable-period').click(function() {
    const $addBtn = $(this)
    const nextID = Number($addBtn.data('size')) + 1
    const $template = $('#unavailable-period-row-template').first().contents().clone()
    const $startInput = $template.find('[id$="start_at"]')
    const $endInput = $template.find('[id$="end_at"]')
    const $deleteBtn = $template.find('.remove-unavailable-period')
    $startInput.val('')
    $startInput.attr('id', `office_viewing_setting_viewing_setting_unavailable_periods_${nextID}_start_at`)
    $startInput.flatpickr(pickerOptions)
    $endInput.val('')
    $endInput.attr('id', `office_viewing_setting_viewing_setting_unavailable_periods_${nextID}_end_at`)
    $endInput.flatpickr(pickerOptions)
    $deleteBtn.click(removeRow)
    $template.insertBefore($addBtn)
    $addBtn.data('size', nextID)

    if (nextID >= unavailablePeriodLimit) {
      $addBtn.addClass('disabled')
    }
  })

  $('.office-viewing-setting .remove-unavailable-period').click(removeRow)
  $('.office-viewing-setting .unavailable-period-picker').flatpickr(pickerOptions)

  const paramInserter = new ParamInserter('.body textarea', '.subject input')
  paramInserter.bind('.office-viewing-setting')
})
